import { NextPage } from 'next';
import AudienceEngagementPage from '@sy/app-client/src/ssrAdapter/pages/AudienceEngagementPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const AudienceEngagement: NextPage<InferProps<typeof getServerSideProps>> = ({
	navigation,
	user,
}) => (
	<MarketingTemplate
		activePage="/audience-engagement"
		navigation={navigation}
		user={user}
	>
		<AudienceEngagementPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.audienceEngagement'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: [
		'common',
		'auth',
		'landing',
		'landingAudienceEngagement',
	],
});

export default AudienceEngagement;
